import React from 'react';

const PlayerDefault = () => (
  <h1>player default</h1>
);

export default PlayerDefault;
